import Layout from '../layout/Layout';
import Alert from 'react-bootstrap/Alert';
import Spinner from 'react-bootstrap/Spinner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram } from '@fortawesome/free-brands-svg-icons';
import { useCloudinaryFolder } from '../hooks/useCloudinaryImages';

export default function About() {
  const { images, loading, error } = useCloudinaryFolder('about');
  const aboutImage = images[0];

  return (
    <Layout>
      <div className="container container-about">
        {error ? <Alert variant="danger">{error}</Alert> : null}

        <div className="row align-items-center">
          <div className="col-lg-5 text-center pb-5">
            {loading ? (
              <Spinner animation="border" />
            ) : aboutImage ? (
              <img
                src={aboutImage.url}
                className="img-fluid about-img"
                alt="Retrato de Santiago Aquino"
              />
            ) : (
              <div className="text-muted">No hay imagen cargada para About.</div>
            )}
          </div>

          <div className="col-lg-7 text-about ps-lg-5">
            <p>
              En 2011 comence mis estudios en la Licenciatura de Fotografia en
              el IENBA, los cuales finalice en 2016.
            </p>
            <p>
              En 2019, tuve la oportunidad de exhibir mi trabajo titulado
              "Interioridad Rasgada". Esta exposicion consistio en una seleccion
              de retratos y autorretratos la cual se llevo a cabo en la sala de
              exposiciones Aurelio Gonzalez de la escuela de fotografia
              Aquelarre, ubicada en Montevideo y en el Museo Agustin Araujo,
              localizado en Treinta y Tres.
            </p>
            <p>
              En la actualidad, me dedico principalmente a trabajar en el campo
              de la belleza y los retratos.
            </p>

            <div className="about-contact">
              <a href="mailto:savfotografia@gmail.com">
                savfotografia@gmail.com
              </a>

              <a
                href="https://www.instagram.com/santiagoaquinofoto"
                target="_blank"
                rel="noreferrer"
                className="about-instagram"
              >
                <FontAwesomeIcon icon={faInstagram} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
